import React from 'react';
import { call, put, select, delay } from 'redux-saga/effects';
import axios from 'axios';
import { message } from 'antd';
import Type from '../redux/actions';

const API_ROOT = '/ic/court/api/v1';

/**
 * 接口请求
 * @param url
 * @param option [, params(url参数), [, data(body参数)]]
 */
export function* normalReqest(url = '', option = { method: 'get' }) {
  const { app } = yield select()
  const token = app.token
  const headers = {
    'Content-Type': 'application/json',
    Authorization: token,
    'Cache-Control': 'no-cache'
  };
  try {
    const res = yield call(axios, {
      url: API_ROOT + url,
      headers,
      ...option,
    })
    return res.data;
  } catch (error) {
    switch (error.response?.status) {
      case 400:
        yield put({ type: 'HIDE_LOADING' });
        message.error(error.response.data?.des || error.response?.des)
        return;
      case 401:
        yield call(hanldeError)
        return;
      case 500:
        message.error('服务器异常');
        return;
      default:
        return;
    }
  }
}

/**
 * 上传接口请求
 * @param url
 * @param option [, params(url参数), [, data(body参数)]]
 */
export function* uploadRequest(url = '', option = { method: 'post', timeout: 120000 }) {
  const { app } = yield select()
  const token = app.token
  const headers = {
    Authorization: token,
  };
  try {
    const res = yield call(axios, {
      url: API_ROOT + url,
      headers,
      ...option
    })
    return res.data;
  } catch (error) {
    switch (error.response?.status) {
      case 400:
        yield put({ type: 'HIDE_LOADING' });
        error.response || message.error(error.response.data?.des)
        return;
      case 401:
        yield call(hanldeError)
        return;
      case 500:
        message.error('服务器异常');
        return;
      default:
        return;
    }
  }
}

function* hanldeError() {
  yield message.error('登录超时或无权限请重新登录');
  yield put({ type: Type.CLEAR_MENU })
  // yield put({ type: 'RESET_ALL_REDUCER_STATE' })
  sessionStorage.clear();
  yield (window.location = '/');
}
